import { render } from "./ViewTeacher.vue?vue&type=template&id=6fc604f6&scoped=true"
import script from "./ViewTeacher.vue?vue&type=script&lang=ts"
export * from "./ViewTeacher.vue?vue&type=script&lang=ts"

import "./ViewTeacher.vue?vue&type=style&index=0&id=6fc604f6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6fc604f6"

export default script